import BaseForm from "../form";
import StandsApi from "../../api/references/stands";
import {
    Avatar,
    Button,
    ButtonGroup,
    Div, FormItem, ModalPage,
    ModalRoot,
    Panel,
    PanelHeader,
    PanelHeaderButton,
    SplitCol,
    SplitLayout, Title
} from "@vkontakte/vkui";
import {Icon16Clear, Icon24BrowserBack, Icon24CameraOutline, Icon28PicturePlusOutline} from "@vkontakte/icons";
import {AdaptivityContext, base_url_stage, getGUID} from "../../assets/constants";
import React from "react";
import TakeAPhoto from "../../components/TakeAPhoto";
import * as constants from "../../assets/constants";
import Fancybox from "../../assets/fancybox";
import SelectObject from "../../assets/SelectObject";
import TrademarkSelectObject from "../trademarks/TrademarkSelectObject";


class StandForm extends BaseForm {

    constructor(props) {
        super(props);
        const state = {
            numImage: 0,

        }
        this.state = {
            ...this.state,
            ...state
        }
    }

    doSave = (item) => {
        if (this.props.fromDoc && (!Array.isArray(item.images) || item.images.length == 0)) {
            window.postMessage({
                type: 'error',
                text: 'Необходимо сделать фото стенда!',
                timeout: 1500,
                hideSpinner: true
            })
        }
        item.confirmed = this.props.fromDoc ? 0 : 1
        StandsApi.save(item).then(result => {
            const {data} = result
            if (data.id) {
                window.postMessage({
                    type: this.props.fromDoc ? 'addBrandToMonitoring' : this.props.eventType,
                    value: data
                })
                window.postMessage({type: 'success', text: 'Данные сохранены', timeout: 1500, hideSpinner: true})
            }
        })
    }

    receiveMessage = (event) => {

        if (event.data.type == "brand_form_photo") {

            const {item} = this.props

            if (!Array.isArray(item.images)) {
                item.images = []
            }

            const old = item.images[event.data.data.numImage] ?? {}

            old.hasImage = true
            old.mainImage = event.data.data.image
            old.thumb = event.data.data.thumb

            item.images[event.data.data.numImage] = old

            window.postMessage({type: this.props.eventType, value: item})

        }
    }
    clearPhoto = (num = 0) => {
        const {item} = this.props

        if (!Array.isArray(item.images)) {
            item.images = []
        }
        if (item.images[num]) {
            item.images.splice(num, 1)


            window.postMessage({type: this.props.eventType, value: item})
        }
    }
    getPhoto = (num = 0) => {

        this.setState({numImage: num})
        this.setActiveModal(constants.MODAL_TAKE_A_PHOTO)
    }
    renderSelectObject = (fieldName, field) => {
        const {fields} = this.state

        if (fieldName == 'parent_id' && !fields['is_competitor'].value) {
            return null
        }
        const Picker = fieldName === 'trade_mark_id' ? TrademarkSelectObject : SelectObject
        return <FormItem top={field.title} bottom={field.error}
                         status={field.error ? 'error' : ''}>
            <Picker
                only_btn
                size="s"
                disabled={field.disabled}
                current_user={this.props.current_user}
                app={field.app}
                act={field.act}
                params={field.params && this.props.item.id ? field.params.replace('{self_id}', this.props.item.id) : ''}
                default={field.value}
                modal_title={field.modal_title}
                create_action={fieldName === 'trade_mark_id'}
                selectObject={e => this.onFieldChange(e, fieldName)}
            />

        </FormItem>
    }

    render() {

        const {item} = this.props
        if (!item) return
        if (!Array.isArray(item.images)) {
            item.images = []
        }

        const cnt = item.images.length
        let maxId = cnt


        const base_url = constants.DEBUG ? constants.url_stage : constants.url_prod
        const images_url = base_url.replace("frontend/", '');

        const modals = <ModalRoot activeModal={this.state.activeModal}>
            <ModalPage
                id={constants.MODAL_TAKE_A_PHOTO}
                onClose={this.modalBack}
            >
                <TakeAPhoto eventName={'brand_form_photo'}
                            destination="brands"
                            numImage={this.state.numImage}
                            hidePhotos={() => this.setActiveModal(null)}
                            url={base_url}
                            openErrorNoty={this.openErrorNoty}/>
            </ModalPage>
        </ModalRoot>


        return <SplitLayout modal={modals}>
            <SplitCol>
                <PanelHeader style={{whiteSpace: "pre-line"}} before={

                    <PanelHeaderButton onClick={() => this.cmdBack()}
                                       key="cmd_back_form"><Icon24BrowserBack/></PanelHeaderButton>}>
                    {item && item.id > 0 ? `${this.props.title} ${item.title}` : this.props.title_new}
                </PanelHeader>
                <Panel>
                    {this.props.fromDoc && <Div>
                        <p style={{color: 'red'}}>Внимание! Добавлять новый стенд нужно только если Вы не нашли его
                            через поиск!</p>
                    </Div>}
                    <Div>
                        {this.renderFields()}
                    </Div>


                    <Div>
                        <Title>Фотографии</Title>
                    </Div>
                    <Div className="incoming-photos-gallery stand-form-photos">
                        <Fancybox key={'IncomingMonitoringFancyBox' + getGUID()}>
                            <div className="main-catalog_product-wrapper_avatar"
                                 style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                <Button mode="secondary"
                                        onClick={() => this.getPhoto(maxId)}
                                        style={{width: "100px"}}><Icon28PicturePlusOutline
                                    height={100}/></Button>
                            </div>
                            {item.images && Array.isArray(item.images) && item.images.map((img_item, index) => {

                                if (!img_item) return
                                return (
                                    <div className="main-catalog_product-wrapper_avatar" key={`galleryBrand${index}`}
                                         style={{width: AdaptivityContext.isMobile ? '108px' : '268px'}}>
                                        {img_item.hasImage ?

                                            [<a data-fancybox={'galleryIncoming2'}
                                                href={images_url + img_item.mainImage.replace('https:/l', 'https://l').replace(images_url, '')}>
                                                {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                         size={AdaptivityContext.isMobile ? 100 : 260}
                                                         src={img_item.thumb}/>}
                                            </a>,
                                                <ButtonGroup style={{
                                                    justifyContent: 'space-between',
                                                    position: "absolute",
                                                    marginTop: '-85px',
                                                    width: AdaptivityContext.isMobile ? '100px' : '260px'
                                                }}>
                                                    <Button mode="primary" size="s"
                                                            className="btn-gallery-actions"
                                                            onClick={() => {
                                                                this.getPhoto(index)
                                                            }} before={<Icon24CameraOutline/>}></Button>
                                                    <Button mode="primary" size="s"
                                                            className="btn-gallery-actions"
                                                            onClick={() => {
                                                                this.clearPhoto(index)
                                                            }} before={<Icon16Clear/>}></Button>
                                                </ButtonGroup>]
                                            :
                                            <Avatar mode="image" style={{borderRadius: '5%'}}
                                                    onClick={() => {
                                                        this.getPhoto(index)
                                                    }}
                                                    size={AdaptivityContext.isMobile ? 100 : 260}
                                                    src={images_url + constants.EMPTY_IMG}/>
                                        }
                                    </div>
                                )

                            })}
                        </Fancybox>
                    </Div>

                    <Div className="action-board">
                        <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>

                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.cmdBack()}>Отмена</Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.save()}>Сохранить</Button>
                        </ButtonGroup>
                    </Div>
                </Panel>
            </SplitCol>
        </SplitLayout>
    }
}

export default StandForm